export const PRISM_APP_URL = 'https://world.org/mini-app?app_id=app_df74242b069963d3e417258717ab60e7';
export const FEATURED_APP_URL = 'https://world.org/mini-app?app_id=app_8c38e825e798ab929b7fbab311afb6a4';
